import React from 'react';
import PropTypes from 'prop-types';
import { Col , Popconfirm } from 'antd';
import moment from 'moment';
import css from '@emotion/css';
import { observer,inject } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import IconSvg from '../../common/IconSvg';
import ENUMS_TRANSFORM from '../../../constants/transformToEnum';
import { LogoContainer, CustomRow } from './styled';
import { PasswordEditor } from './PasswordEditor';

// const DisabledGlobalShipping = () => (
//   <Popover
//     content="Global Shipping is currently disabled."
//     title=""
//     trigger="hover"
//     placement="top"
//   >
//     <IconSvg color="#a3a3a3" type="globe" size={20} />
//   </Popover>
// );

@inject('settingsStore')
@observer
class AccountConnectionDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      allowGlobal: props.account.allowGlobalShipping,
      hasGlobalItemsInProcess:false
    };
  }

  getName = (isBuyItForMeAccount, marketplaceTypeId, name, last4Digits) => {
    if (isBuyItForMeAccount) return <FormattedMessage id="settingsModal.bifmAccount" />;
    if (marketplaceTypeId === 'stripe')
      return (
        <div
          css={css`
            margin-top: 10px;
          `}
        >
          {name}
          <div>**** **** **** {last4Digits}</div>
        </div>
      );
    return name;
  };

  render() {
    const {
      account: {
        status,
        name,
        marketplaceTypeId,
        id,
        dateStatusChecked,
        dateCreated,
        last4Digits,
        isBuyItForMeAccount = false,
      },
      deleteAccount,
      reconnectAccount,
      connectGlobal,
      disconnectGlobal,
      type,
      isDefault,
      isNonApi,
      editPassword = () => {},
      currency,
      settingsStore :{
        // userProfile,
        connectionManagement :{
          checkHasGlobalItemsInProcess
        }
      },
    } = this.props;
    const { hasGlobalItemsInProcess }=this.state;
    return (
      <CustomRow gutter={16}>
        <Col span={0.5}>
          <IconSvg
            size={16}
            type={status === 'connected' || !status ? 'link-connected' : 'link-disconnected'}
          />
          <span
            css={css`
              margin: 0 5px;
            `}
          >
            {type === 'destination' && currency === 'USD' ? (
              <span className="global-shipping">
                {/* Uncomment the code below to reinitialize the
                    global shipping functionality
                */}
                {this.state.allowGlobal && (
                  <Popconfirm
                    title={hasGlobalItemsInProcess ? "There are items in process of revise right now. Please come back in few minutes"
                      :"You are about to disconnect the store from Global Shipping."}
                    okText={hasGlobalItemsInProcess ? "Ok" : "Disconnect"}
                    onClick={()=>{checkHasGlobalItemsInProcess(id).then((resp)=>{
                      this.setState({hasGlobalItemsInProcess:resp})
                    })}}
                    onConfirm={() =>{
                      if(!hasGlobalItemsInProcess){
                        disconnectGlobal(id).then(() => this.setState({ allowGlobal: false }))
                      }
                    }
                  }
                  >
                    <IconSvg type="globe" size={20} />
                  </Popconfirm>
                )}

                {!this.state.allowGlobal && (
                  <Popconfirm
                    title={hasGlobalItemsInProcess ? "There are items in process of revise right now. Please come back in few minutes"
                      :"You are about to connect the store to Global Shipping."}
                    okText={hasGlobalItemsInProcess ? "Ok":"Connect"}
                    onClick={()=>{checkHasGlobalItemsInProcess(id).then((resp)=>{
                      this.setState({hasGlobalItemsInProcess:resp})
                    })}}
                    onConfirm={() =>{
                      if(!hasGlobalItemsInProcess){
                        connectGlobal(id).then(() => this.setState({ allowGlobal: true }))
                      }
                    }
                    }
                  >
                    <IconSvg color="#a3a3a3" type="globe" size={20} />
                  </Popconfirm>
                )}

                {/* {!userProfile.isBetaUser && (<DisabledGlobalShipping />)} */}
              </span>
            ) : null}
          </span>
        </Col>
        <Col span={currency === 'USD' && type === 'destination' ? 2 : 1.5}>
          <div
            css={css`
              width: 32px;
              text-align: center;
            `}
          >
            <LogoContainer marketPlaceName={ENUMS_TRANSFORM.MARKETSold[marketplaceTypeId]} />
          </div>
        </Col>
        <Col span={7}>
          <span>{this.getName(isBuyItForMeAccount, marketplaceTypeId, name, last4Digits)}</span>
        </Col>
        <Col span={2}>
          <span
            className="delete"
            css={css`
              margin-right: 5px;
            `}
          >
            {!isBuyItForMeAccount && (
              <IconSvg
                size={14}
                type={isDefault ? 'info' : 'delete'}
                onClick={() => deleteAccount(id, type)}
              />
            )}
          </span>
          {type === 'destination' ? (
            <span className="reconnect" hidden={isNonApi}>
              <IconSvg size={18} type="reconnect" onClick={reconnectAccount} />
            </span>
          ) : null}
        </Col>
        <Col span={2} style={{ color: '#999999' }}>
          <i>{dateStatusChecked && moment(dateStatusChecked).format('MMMM Do YYYY, h:mm:ss A')}</i>
          <i>{dateCreated && moment(dateCreated).format('MMMM Do YYYY, h:mm:ss A')}</i>
          {type === 'source' && !isBuyItForMeAccount ? (
            <PasswordEditor onSave={newPassword => editPassword(id, name, newPassword)} />
          ) : null}
        </Col>
      </CustomRow>
    );
  }
}

AccountConnectionDisplay.propTypes = {
  account: PropTypes.object,
  deleteAccount: PropTypes.func,
  type: PropTypes.string,
  isDefault: PropTypes.bool,
  reconnectAccount: PropTypes.func,
  editPassword: PropTypes.func,
  connectGlobal: PropTypes.func,
  disconnectGlobal: PropTypes.func,
  isNonApi: PropTypes.bool,
};

export default observer(AccountConnectionDisplay);
